import React, { Component } from 'react';
import { NavMenu } from './NavMenu';
import { SideBar } from './SideBar';
import { Footer } from './Footer';
import { config } from '../Constants';
import CacheBuster from '../CacheBuster';


export class Layout extends Component {
    static displayName = Layout.name;
    constructor(props) {
        super(props);
        this.state = {
            token: '',
            remitterCode: ''
        }

        this.state.token = localStorage.getItem('token');

        if (config.url.EnvType == "PROD" || config.url.EnvType == "DEV") {
            this.state.remitterCode = window.location.pathname.split('/')[1];
        }
        else {
            this.state.remitterCode = window.location.pathname.split('/')[2];
        } 

    }

    isValid() {
        // Base URLs for each environment
        const baseUrls = {
            LOCAL: '',
            PROD: '',
            DEV: '/intranet/Dev/EasyDebenturesUnitholderPortal/UI',
            QA: '/intranet/QA/EasyDebenturesUnitholderPortal/UI',
            PREPROD: '/intranet/PreProd/EasyDebenturesUnitholderPortal/UI',
            UAT: '/intranet/UAT/EasyDebenturesUnitholderPortal/UI',
        };

        // Common paths including remitterCode paths
        const { remitterCode, token } = this.state;
        const commonPaths = [
            '/',
            '/Error/404',
            '/Error/Browser-Not-Supported',
            '/SignUp',
            '/SignIn',
            '/ResetPassword',
            '/Resident',
            '/Resident/Dashboard',
            '/Resident/SendEmail',
            '/NonResident',
            '/NonResident/FileUpload',
            '/Resident/Form15GH',
            '/Nexdigm/Dashboard',
            '/Nexdigm/Assignment',
            '/Nexdigm/Add-Assignment',
            '/Nexdigm/Shareholder-Details',
            '/Nexdigm/View-Shareholder',
            `/${remitterCode}/userProfile`,
            `/${remitterCode}/Forgot-Password`,
            `/${remitterCode}/New-User`,
            `/${remitterCode}`
        ];

        // Get the base URL and paths for the current environment
        const envType = config.url.EnvType;
        const baseUrl = baseUrls[envType] || '';
        const validPaths = commonPaths;

        // Check token validity for DEV and LOCAL environments
        const isTokenInvalid = (envType === "DEV" || envType === "LOCAL") && token == null;

        // Validate the current path
        const fullPath = `${baseUrl}${window.location.pathname}`;
        const isPathValid = validPaths.some(path => fullPath.endsWith(path));

        return !isTokenInvalid && isPathValid;
    }


    isValidOld() {
        let isValid = true

        if (config.url.EnvType == "DEV") {
            if (this.state.token == null) isValid = false;
            if (window.location.pathname == `/${this.state.remitterCode}/userProfile`) isValid = true;
            if (window.location.pathname == `/${this.state.remitterCode}/Forgot-Password`) isValid = true;
            if (window.location.pathname == `/${this.state.remitterCode}/New-User`) isValid = true;
            if (window.location.pathname == `/${this.state.remitterCode}/userProfile`) isValid = true;
            if (window.location.pathname == `/`) isValid = true;
            if (window.location.pathname == `/Error/404`) isValid = true;
            if (window.location.pathname == `/Error/Browser-Not-Supported`) isValid = true;
            if (window.location.pathname == `/${this.state.remitterCode}/Forgot-Password`) isValid = true;
            if (window.location.pathname == `/${this.state.remitterCode}/New-User`) isValid = true;
            if (window.location.pathname == `/SignUp`) isValid = true;
            if (window.location.pathname == `/SignIn`) isValid = true;
            if (window.location.pathname == `/ResetPassword`) isValid = true;
            if (window.location.pathname == `/Resident`) isValid = true;
            if (window.location.pathname == `/Resident/Dashboard`) isValid = true;
            if (window.location.pathname == `/Resident/SendEmail`) isValid = true;
            if (window.location.pathname == `/NonResident`) isValid = true;
            if (window.location.pathname == `/NonResident/FileUpload`) isValid = true;
            if (window.location.pathname == `/Resident/Form15GH`) isValid = true;
            if (window.location.pathname == `/Nexdigm/Dashboard`) isValid = true;
            if (window.location.pathname == `/Nexdigm/Assignment`) isValid = true;
            if (window.location.pathname == `/Nexdigm/Add-Assignment`) isValid = true;
            if (window.location.pathname == `/Nexdigm/Shareholder-Details`) isValid = true;
            if (window.location.pathname == `/Nexdigm/View-Shareholder`) isValid = true;
            if (window.location.pathname == `/Nexdigm/Part2`) isValid = true;
            if (window.location.pathname == `/Nexdigm/Report`) isValid = true;          
        }
        else if(config.url.EnvType == "PROD") {
            if (window.location.pathname == `/${this.state.remitterCode}/userProfile`) isValid = true;
            if (window.location.pathname == `/${this.state.remitterCode}/Forgot-Password`) isValid = true;
            if (window.location.pathname == `/${this.state.remitterCode}/New-User`) isValid = true;
            if (window.location.pathname == `/${this.state.remitterCode}`) isValid = true;
            if (window.location.pathname == `/${this.state.remitterCode}/userProfile`) isValid = true;
            if (window.location.pathname == `/`) isValid = true;
            if (window.location.pathname == `/Error/404`) isValid = true;
            if (window.location.pathname == `/Error/Browser-Not-Supported`) isValid = true;
            if (window.location.pathname == `/Error/404`) isValid = true;
            if (window.location.pathname == `/Error/Browser-Not-Supported`) isValid = true;
            if (window.location.pathname == `/Nexdigm/Dashboard`) isValid = true;
            if (window.location.pathname == `/Nexdigm/Assignment`) isValid = true;
            if (window.location.pathname == `/Nexdigm/Add-Assignment`) isValid = true;
            if (window.location.pathname == `/Nexdigm/Shareholder-Details`) isValid = true;
            if (window.location.pathname == `/Nexdigm/View-Shareholder`) isValid = true;
            if (window.location.pathname == `/SignUp`) isValid = true;
            if (window.location.pathname == `/SignIn`) isValid = true;
            if (window.location.pathname == `/ResetPassword`) isValid = true;
            if (window.location.pathname == `/Resident`) isValid = true;
            if (window.location.pathname == `/Resident/SendEmail`) isValid = true;
            if (window.location.pathname == `/Resident/Dashboard`) isValid = true;
            if (window.location.pathname == `/NonResident`) isValid = true;
            if (window.location.pathname == `/NonResident/FileUpload`) isValid = true;
            if (window.location.pathname == `/Resident/Form15GH`) isValid = true;
        }
        else if (config.url.EnvType == "UAT") {
            if (window.location.pathname == `/intranet/UAT/EasyDebenturesUnitholderPortal/UI/${this.state.remitterCode}/userProfile`) isValid = true;
            if (window.location.pathname == `/intranet/UAT/EasyDebenturesUnitholderPortal/UI/${this.state.remitterCode}/Forgot-Password`) isValid = true;
            if (window.location.pathname == `/intranet/UAT/EasyDebenturesUnitholderPortal/UI/${this.state.remitterCode}/New-User`) isValid = true;
            if (window.location.pathname == `/intranet/UAT/EasyDebenturesUnitholderPortal/UI/${this.state.remitterCode}`) isValid = true;
            if (window.location.pathname == `/intranet/UAT/EasyDebenturesUnitholderPortal/UI/${this.state.remitterCode}/userProfile`) isValid = true;
            if (window.location.pathname == `/intranet/UAT/EasyDebenturesUnitholderPortal/UI/`) isValid = true;
            if (window.location.pathname == `/EasyDebentures/Error/404`) isValid = true;
            if (window.location.pathname == `/EasyDebentures/Error/Browser-Not-Supported`) isValid = true;
            if (window.location.pathname == `/intranet/UAT/EasyDebenturesUnitholderPortal/UI/Error/404`) isValid = true;
            if (window.location.pathname == `/intranet/UAT/EasyDebenturesUnitholderPortal/UI/Error/Browser-Not-Supported`) isValid = true;
            if (window.location.pathname == `/intranet/UAT/EasyDebenturesUnitholderPortal/UI/Nexdigm/Dashboard`) isValid = true;
            if (window.location.pathname == `/intranet/UAT/EasyDebenturesUnitholderPortal/UI/Nexdigm/Assignment`) isValid = true;
            if (window.location.pathname == `/intranet/UAT/EasyDebenturesUnitholderPortal/UI/Nexdigm/Add-Assignment`) isValid = true;
            if (window.location.pathname == `/intranet/UAT/EasyDebenturesUnitholderPortal/UI/Nexdigm/Shareholder-Details`) isValid = true;
            if (window.location.pathname == `/intranet/UAT/EasyDebenturesUnitholderPortal/UI/Nexdigm/View-Shareholder`) isValid = true;
            if (window.location.pathname == `/intranet/UAT/EasyDebenturesUnitholderPortal/UI/SignUp`) isValid = true;
            if (window.location.pathname == `/intranet/UAT/EasyDebenturesUnitholderPortal/UI/SignIn`) isValid = true;
            if (window.location.pathname == `/intranet/UAT/EasyDebenturesUnitholderPortal/UI/ResetPassword`) isValid = true;
            if (window.location.pathname == `/intranet/UAT/EasyDebenturesUnitholderPortal/UI/Resident`) isValid = true;
            if (window.location.pathname == `/intranet/UAT/EasyDebenturesUnitholderPortal/UI/Resident/SendEmail`) isValid = true;
            if (window.location.pathname == `/intranet/UAT/EasyDebenturesUnitholderPortal/UI/Resident/Dashboard`) isValid = true;
            if (window.location.pathname == `/intranet/UAT/EasyDebenturesUnitholderPortal/UI/NonResident`) isValid = true;
            if (window.location.pathname == `/intranet/UAT/EasyDebenturesUnitholderPortal/UI/NonResident/FileUpload`) isValid = true;
            if (window.location.pathname == `/intranet/UAT/EasyDebenturesUnitholderPortal/UI/Resident/Form15GH`) isValid = true;
        }
        else  {
            if (this.state.token == null) isValid = false;
            if (window.location.pathname == `/EasyDividendPhase2/${this.state.remitterCode}/userProfile`) isValid = true;
            if (window.location.pathname == `/EasyDividendPhase2/${this.state.remitterCode}/Forgot-Password`) isValid = true;
            if (window.location.pathname == `/EasyDividendPhase2/${this.state.remitterCode}/New-User`) isValid = true;
            if (window.location.pathname == `/EasyDividendPhase2/${this.state.remitterCode}`) isValid = true;
            if (window.location.pathname == `/EasyDividendPhase2/${this.state.remitterCode}/userProfile`) isValid = true;
            if (window.location.pathname == `/EasyDividendPhase2/`) isValid = true;
            if (window.location.pathname == `/Error/404`) isValid = true;
            if (window.location.pathname == `/Error/Browser-Not-Supported`) isValid = true;
            if (window.location.pathname == `/EasyDividendPhase2/Error/404`) isValid = true;
            if (window.location.pathname == `/EasyDividendPhase2/Error/Browser-Not-Supported`) isValid = true;
            if (window.location.pathname == `/EasyDividendPhase2/${this.state.remitterCode}/Forgot-Password`) isValid = true;
            if (window.location.pathname == `/EasyDividendPhase2/${this.state.remitterCode}/New-User`) isValid = true;
            if (window.location.pathname == `/EasyDividendPhase2/${this.state.remitterCode}`) isValid = true;

            if (window.location.pathname == `/EasyDividendPhase2/Nexdigm/Dashboard`) isValid = true;
            if (window.location.pathname == `/EasyDividendPhase2/Nexdigm/Assignment`) isValid = true;
            if (window.location.pathname == `/EasyDividendPhase2/Nexdigm/Add-Assignment`) isValid = true;

            if (window.location.pathname == `/EasyDividendPhase2/Nexdigm/Shareholder-Details`) isValid = true;
            if (window.location.pathname == `/EasyDividendPhase2/Nexdigm/View-Shareholder`) isValid = true;

            if (window.location.pathname == `/EasyDividendPhase2/SignUp`) isValid = true;
            if (window.location.pathname == `/EasyDividendPhase2/SignIn`) isValid = true;
            if (window.location.pathname == `/EasyDividendPhase2/ResetPassword`) isValid = true;


            if (window.location.pathname == `/EasyDividendPhase2/Resident`) isValid = true;
            if (window.location.pathname == `/EasyDividendPhase2/Resident/SendEmail`) isValid = true;

            if (window.location.pathname == `/EasyDividendPhase2/Resident/Dashboard`) isValid = true;
            if (window.location.pathname == `/EasyDividendPhase2/NonResident`) isValid = true;
            if (window.location.pathname == `/EasyDividendPhase2/NonResident/FileUpload`) isValid = true;


            if (window.location.pathname == `/EasyDividendPhase2/Resident/Form15GH`) isValid = true;
        }
       
        return isValid
    }

   
    static RenderNavMenu() {
        return (
            <NavMenu />
        );
    }

    static RenderSideBar() {
        return (
            <SideBar />
        );
    }

    static RenderFooter() {
        return (
            <Footer />
        );
    }

    render() {

        return (
            <CacheBuster>
                {({ loadingNew, isLatestVersion, refreshCacheAndReload }) => {
                    if (!loadingNew && !isLatestVersion) {
                        refreshCacheAndReload();
                    }

                    return (
                        <div>
                            {this.props.children}
                        </div>
                    );
                }}
            </CacheBuster>

            //<div>
            //    {this.props.children}
            //</div>
        );

    }
}
